<template>
    <v-container class="pa-6 pa-lg-12 fill-height align-start" fluid>
        <v-row>
            <v-col cols="12" md="7" lg="6" class="d-flex justify-space-between align-center py-0">
                <div class="d-flex align-center">
                    <span class="headline mr-4">Terms and Conditions</span>
                    <v-btn small depressed color="primary" @click="showCreationDialog = !showCreationDialog">
                        <v-icon left>mdi-plus</v-icon> create
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="7" lg="6" class="py-0">
                <template v-if="!loading">
                    <template v-if="items.length > 0">
                        <v-card outlined width="100%" class="mt-4">
                            <template v-for="(item, index) in items">                                
                                <v-row 
                                    class="px-4"
                                    align="center"
                                    :key="`A${index}`"
                                >
                                    <v-col cols="8" class="flex-grow-1 flex-shrink-0 py-2">
                                        <div class="subtitle-2" v-text="item.text"></div>
                                    </v-col>
                                    <v-col cols="4" class="flex-grow-0 flex-shrink-0 text-right py-2">
                                        <v-btn 
                                            icon
                                            color="primary" 
                                            class="mr-2" 
                                            @click="updateItemEventHandler(item)"
                                        ><v-icon>mdi-pencil</v-icon></v-btn>
                                        <v-btn 
                                            icon
                                            color="secondary" 
                                            @click="deleteItemEventHandler(item.id)"
                                        ><v-icon>mdi-trash-can</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider 
                                    v-if="index + 1 < items.length"
                                    :key="`B${index}`"
                                ></v-divider>
                            </template>
                            <template v-if="offset != -9999">
                                <v-divider></v-divider>
                                <div class="text-center py-4">
                                    <v-btn 
                                        depressed 
                                        small 
                                        color="primary"
                                        :disabled="loadingMore"
                                        :loading="loadingMore"
                                        @click="fetchItems"
                                    >show more</v-btn>
                                </div>
                            </template>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-card outlined class="mt-4">
                            <v-card-subtitle>No items available</v-card-subtitle>
                        </v-card>
                    </template>
                </template>
                <template v-else>
                    <v-card outlined class="mt-4">
                        <v-card-subtitle>Loading...</v-card-subtitle>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <!-- create item dialog -->
        <v-dialog max-width="740" v-model="showCreationDialog">
            <v-card>
                <v-card-title>New term and condition</v-card-title>
                <v-divider></v-divider>
                <div class="pt-6 pb-4 px-6">
                    <v-text-field 
                        dense
                        outlined
                        hide-details
                        class="mb-4"
                        label="Title"
                        v-model="newItemObject.title"
                    ></v-text-field>
                    <v-row class="mb-4">
                        <v-col cols="12" md="6">
                            <v-select 
                                dense
                                outlined
                                hide-details
                                label="User type"
                                :items="userTypes"
                                item-text="name"
                                item-value="id"
                                v-model="newItemObject.userType"
                                :menu-props="{ offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">                            
                            <v-select 
                                dense
                                outlined
                                hide-details
                                label="Language"
                                :items="languages"
                                item-text="label"
                                item-value="id"
                                v-model="newItemObject.languageId"
                                :menu-props="{ offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>                    
                    <vue-editor v-model="newItemObject.description" :editor-toolbar="customToolbar" />
                    <div class="d-flex align-center justify-space-between mt-4">
                        <v-btn
                            depressed
                            small
                            color="primary"
                            @click="createItem"
                        >Save</v-btn>
                        <v-btn
                            depressed
                            small
                            color="secondary"
                            @click="showCreationDialog = false"
                        >Cancel</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <!-- update item dialog -->
        <v-dialog max-width="740" v-model="showUpdateDialog">
            <v-card>
                <v-card-title>Update term and condition</v-card-title>
                <v-divider></v-divider>
                <div class="pt-6 pb-4 px-6">
                    <v-text-field 
                        dense
                        outlined
                        hide-details
                        class="mb-4"
                        label="Title"
                        v-model="updateItemObject.title"
                    ></v-text-field>
                    <v-row class="mb-4">
                        <v-col cols="12" md="6">
                            <v-select
                                dense
                                outlined
                                hide-details
                                label="User type"
                                :items="userTypes"
                                item-text="name"
                                item-value="id"
                                v-model="updateItemObject.userType"
                                :menu-props="{ offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select 
                                dense
                                outlined
                                hide-details
                                label="Language"
                                :items="languages"
                                item-text="label"
                                item-value="id"
                                v-model="updateItemObject.languageId"
                                :menu-props="{ offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>   
                    <vue-editor v-model="updateItemObject.description" :editor-toolbar="customToolbar" />
                    <div class="d-flex align-center justify-space-between mt-4">
                        <v-btn
                            depressed
                            small
                            color="primary"
                            @click="updateItem"
                        >Save</v-btn>
                        <v-btn
                            depressed
                            small
                            color="secondary"
                            @click="showUpdateDialog = false"
                        >Cancel</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <!-- Delete item dialog -->
        <v-bottom-sheet v-model="showDeleteDialog">
            <v-sheet class="text-center py-4">
                <div class="py-3">Are you sure you want to delete this item?</div>
                <v-btn
                    text
                    color="secondary"
                    @click="deleteItem"
                >Yes</v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="showDeleteDialog = false"
                >No</v-btn>
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { VueEditor } from 'vue2-editor'

    export default {
        name: 'termsAndConditions',
        data: () => ({
            items: [],
            newItemObject: {
                title: null,
                languageId: null,
                userType: null,
                description: null
            },
            updateItemObject: {
                id: null,
                title: null,
                languageId: null,
                userType: null,
                description: null
            },
            deleteItemById: null,
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike', 'link'], 
                [{ 'list': 'ordered'}, { 'list': 'bullet' }]
            ],
            offset: 0,
            userTypes: [],
            showCreationDialog: false,
            showUpdateDialog: false,
            showDeleteDialog: false,
            loading: true,
            loadingMore: false,
            snackbar: {
                show: true,
                message: ''
            }
        }),
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters(['user', 'languages'])
        },
        mounted() {
            this.fetchItems()
            this.fetchUserTypes()
        },
        methods: {
            async fetchItems() {
                this.loadingMore = true
                await this.axios.get('/Terms/GetAll', {
                    params: {
                        languageId: 1,
                        amount: 5,
                        offset: this.offset
                    }
                })
                .then(response => {
                    this.items = this.items.concat(response.data.list)
                    this.offset = response.data.offset
                    this.loading = false
                    this.loadingMore = false
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.loading = false
                    this.loadingMore = false
                })
            },
            async fetchUserTypes() {
                await this.axios.get('/User/GetUserTypes?languageId=1')
                .then(response => {
                    response.data.forEach(type => {
                        if(type.id !== 3) {
                            this.userTypes.push(type)
                        }
                    })
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            createItem() {
                const data = {
                    text: this.newItemObject.title,
                    userType: this.newItemObject.userType,
                    languageId: this.newItemObject.languageId,
                    description:this.newItemObject.description
                }
                this.axios.post('/Terms/CreateTerms', data)
                .then(response => {
                    this.items.push(response.data)
                    this.clearObject('create')
                    this.showCreationDialog = false
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            updateItemEventHandler(item) {
                this.updateItemObject.id = item.id
                this.updateItemObject.title = item.text
                this.updateItemObject.userType = item.userType
                this.updateItemObject.languageId = item.languageId
                this.updateItemObject.description = item.description
                this.showUpdateDialog = true
            },
            updateItem() {
                const data = {
                    id: this.updateItemObject.id,
                    text: this.updateItemObject.title,
                    userType: this.updateItemObject.userType,
                    languageId: this.updateItemObject.languageId,
                    description:this.updateItemObject.description
                }
                this.axios.post('/Terms/UpdateTerms', data)
                .then(response => {
                    let index = this.items.map(item => item.id).indexOf(this.updateItemObject.id)
                    this.items[index] = response.data
                    this.showUpdateDialog = false
                    this.clearObject('update')
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            deleteItemEventHandler(id) {
                this.deleteItemById = id
                this.showDeleteDialog = true
            },
            deleteItem() {
                this.axios.delete('/Terms/DeleteTerms', {
                    params: {
                        id: this.deleteItemById
                    }
                })
                .then(response => {
                    let index = this.items.map(item => item.id).indexOf(this.deleteItemById)
                    this.items.splice(index, 1)
                    this.showDeleteDialog = false
                    this.snackbar.message = 'Item deleted successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            clearObject(object) {
                if(object === 'create') {
                    this.newItemObject.title = null
                    this.newItemObject.userType = null
                    this.newItemObject.languageId = null
                    this.newItemObject.description = null
                } else if(object === 'update') {
                    this.updateItemObject.id = null
                    this.updateItemObject.title = null
                    this.updateItemObject.userType = null
                    this.updateItemObject.languageId = null
                    this.updateItemObject.description = null
                }
            }
        }
    }
</script>

<style lang="scss" scoped></style>